package io.horion.cv.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.CSSLengthNumericValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.overlay.Overlay
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.animation.Keyframes
import io.horion.cv.utils.Colors
import org.jetbrains.compose.web.css.*
import com.varabyte.kobweb.silk.style.animation.toAnimation
import com.varabyte.kobweb.compose.css.AnimationIterationCount

import com.varabyte.kobweb.compose.ui.modifiers.animation
import kotlinx.browser.document

val SpinKeyframes = Keyframes {
    from {
        Modifier.rotate(0.deg)
    }
    to {
        Modifier.rotate(360.deg)
    }
}


@Composable
fun LoadingPopup(isLoading: Boolean) {
    if (isLoading) {
        document.body?.style?.setProperty("overflow", "hidden")
        Overlay(
            // On centre le contenu (le Box) à l'intérieur de l'Overlay
            contentAlignment = Alignment.Center,
            modifier = Modifier
                .fillMaxSize()
                .backgroundColor(rgba(0, 0, 0, 0.5))
                .cursor(Cursor.Wait)
                // On s'assure que l'overlay est au-dessus de tout (z-index)
                .zIndex(1000)
        ) {
            Box(
                modifier = Modifier
                    .minSize(150.px)
                    .padding(20.px)
                    .backgroundColor(Colors.White)
                    .borderRadius(12.px)
                    .boxShadow(
                        offsetX = 0.px,
                        offsetY = 4.px,
                        blurRadius = 12.px,
                        color = rgba(0, 0, 0, 0.2)
                    ),
                contentAlignment = Alignment.Center
            ) {
                Column(
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    LoadingSpinner()

                    Box(Modifier.height(15.px))

                    SpanText(
                        text = "Chargement...",
                        modifier = Modifier
                            .color(Colors.Black)
                            .fontWeight(FontWeight.Bold)
                    )
                }
            }
        }
    } else {
        document.body?.style?.removeProperty("overflow")
    }
}

@Composable
fun LoadingSpinner() {
    Box(
        modifier = Modifier
            .size(40.px)
            .border(4.px, LineStyle.Solid, rgba(0, 0, 0, 0.1))
            .borderTop(4.px, LineStyle.Solid, Color.dodgerblue)
            .borderRadius(50.percent)
            .animation(
                SpinKeyframes.toAnimation(
                    duration = 1.s,
                    timingFunction = AnimationTimingFunction.Linear,
                    iterationCount = AnimationIterationCount.Infinite
                )
            )
    )
}